import { render, staticRenderFns } from "./TestimonialHomeOne.vue?vue&type=template&id=dd194e56"
import script from "./TestimonialHomeOne.vue?vue&type=script&lang=js"
export * from "./TestimonialHomeOne.vue?vue&type=script&lang=js"
import style0 from "./TestimonialHomeOne.vue?vue&type=style&index=0&id=dd194e56&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports